import React from 'react';
import { currentEntitlementType, getParentContainerId } from '@css-xp/base/entitlement-utils';
import {
  LinkedEntitlementTypes,
  LinkedProductTypes,
  EntitlementDetails,
  FilterOption,
} from '@css-xp/graphtypes/src/generated-types-new';
import { INVOICE_TABLE_UTILS } from '@css-xp/ppc-utils';
import { useFetchInvoicesForTransactionAccountPPCQuery } from '@css-xp/ppc-api';
import { useFetchOrdersForTransactionAccountPPCQuery } from '@css-xp/ppc-order-history-table';
import { useFetchLinkedEntitlementsPPCQuery } from '../../../hooks/use-fetch-linked-entitlements-ppc-query';
import { useFetchUsageHistoryForEntitlementPPCQuery } from '../product-usage-tab/use-fetch-user-history-for-entitlement-ppc-query';
import { useFetchEndCustomerContactstPPCQuery } from '../customer-contacts-tab/use-fetch-end-customer-contacts-ppc-query';

export const CacheEntitlementPageTabsGraphqlQuery = ({
  transactionAccountId,
  entitlementDetails,
  invoiceTableFilter,
  orderHistoryFilterOptions,
  highestUsageParentEntitlementId,
}: {
  transactionAccountId: string;
  entitlementDetails: EntitlementDetails;
  invoiceTableFilter: FilterOption[] | Record<string, string>[];
  orderHistoryFilterOptions: FilterOption[];
  highestUsageParentEntitlementId: string;
}) => {
  useFetchLinkedEntitlementsPPCQuery({
    containerId: getParentContainerId(entitlementDetails),
    entitlementId: entitlementDetails.id,
    currentEntitlementType: currentEntitlementType(entitlementDetails),
    destinationEntitlementType: [LinkedEntitlementTypes.PROD_ENTITLEMENT_APP],
    productType: entitlementDetails.productType as LinkedProductTypes,
    findApps: true,
    findProducts: false,
    transactionAccountId: transactionAccountId,
    skipOption: !!entitlementDetails?.isApp,
  });
  useFetchInvoicesForTransactionAccountPPCQuery({
    txaId: transactionAccountId,
    filterOptions: INVOICE_TABLE_UTILS.getFilterOptions({ filters: invoiceTableFilter }),
  });
  useFetchOrdersForTransactionAccountPPCQuery({
    transactionAccountId: transactionAccountId,
    filterOptions: orderHistoryFilterOptions,
  });
  useFetchUsageHistoryForEntitlementPPCQuery({
    entitlementId: entitlementDetails.id,
    transactionAccountId: transactionAccountId,
    highestUsageParentEntitlementId: highestUsageParentEntitlementId,
  });
  useFetchEndCustomerContactstPPCQuery({
    transactionAccountId: transactionAccountId,
    entitlementId: entitlementDetails.id,
  });
  return null;
};
